const Tabs = {
  el: {
    tabItems: document.querySelectorAll<HTMLElement>('.tabs-block__tab-pill'),
    activePill: document.querySelector<HTMLElement>('.tabs-block__active-pill'),
    widthMatch: window.matchMedia('(max-width: 992px)'),
  },

  init() {
    //on load we the trigger the positioning of the active pill
    Tabs.triggerPositioning(Tabs.el.widthMatch)

    //when windowsize changes we the trigger the positioning of the active pill
    window.addEventListener('resize', () => {
      Tabs.triggerPositioning(Tabs.el.widthMatch)
    })

    //listen to clicks on tabs
    Array.prototype.forEach.call(this.el.tabItems, (tabItem) => {
      tabItem.addEventListener('click', this.toggleTabs)
    })
  },

  //trigger the positioning of the active pill
  triggerPositioning(mm) {
    if (Tabs.el.tabItems) {
      Array.prototype.forEach.call(Tabs.el.tabItems, (tabItem) => {
        if (tabItem.classList.contains('tabs-block__tab-pill--active')) {
          Tabs.el.activePill.classList.add('tabs-block__active-pill--show')
          Tabs.positionActivePill(tabItem, Tabs.checkWindowSize(mm))
        }
      })
    }
  },

  //set the size
  checkWindowSize(mm) {
    let size = ''

    if (mm.matches) {
      size = 'small'
    } else {
      size = 'large'
    }

    return size
  },

  toggleBody(index, type) {
    const body = document.querySelector(
      '.tabs-block__body-container[data-index="' + index + '"]'
    )

    if (type == 'select') {
      body.classList.add('tabs-block__body-container--show')
    }

    if (type == 'unselect') {
      body.classList.remove('tabs-block__body-container--show')
    }
  },

  toggleTabs(event) {
    const tabItem = event.currentTarget
    const tabItemIsSelected = tabItem.classList.contains('tabs-block__tab-pill--active')
    const tabsBlock = tabItem.parentElement

    if (!tabItemIsSelected) {
      //close opened items
      const selectedItem = tabsBlock.querySelector('.tabs-block__tab-pill--active')

      if (selectedItem) {
        Tabs.unselectItem(selectedItem)
      }
      // open the item
      Tabs.selectItem(tabItem)
    } else {
      // close current item (if it was opened)
      Tabs.el.activePill.classList.remove('tabs-block__active-pill--show')
      Tabs.unselectItem(tabItem)
    }
  },

  positionActivePill(tabItem, size) {
    const tabItems = Array.prototype.slice.call(this.el.tabItems)
    const index = tabItems.indexOf(tabItem)

    if (size == 'large') {
      this.el.activePill.style.top = `50%`
      this.el.activePill.classList.add('animate')

      if (index == 0) {
        this.el.activePill.style.left = `${tabItem.offsetLeft + 4}px`
      }

      if (index == 1) {
        this.el.activePill.style.left = `${tabItem.offsetLeft + 2}px`
      }

      if (index == 2) {
        this.el.activePill.style.left = `${tabItem.offsetLeft}px`
      }
    }

    if (size == 'small') {
      this.el.activePill.style.left = `${4}px`
      this.el.activePill.style.top = `${tabItem.offsetTop}px`
    }

    // Tabs.styleActivePill(tabItem)
  },

  // styleActivePill(tabItem) {
  //   this.el.activePill.classList.add('tabs-block__active-pill--hovering')

  //   tabItem.addEventListener("mouseenter", () => {
  //     this.el.activePill.classList.add('tabs-block__active-pill--hovering')
  //   })

  //   tabItem.addEventListener("mouseleave", () => {
  //     this.el.activePill.classList.remove('tabs-block__active-pill--hovering')
  //   })
  // },

  unselectItem(tabItem) {
    tabItem.classList.remove('tabs-block__tab-pill--active')
    Tabs.toggleBody(tabItem.dataset.index, 'unselect')
  },

  selectItem(tabItem) {
    Tabs.el.activePill.classList.add('tabs-block__active-pill--show')
    tabItem.classList.add('tabs-block__tab-pill--active')

    const windowSize = Tabs.checkWindowSize(this.el.widthMatch)
    Tabs.positionActivePill(tabItem, windowSize)
    Tabs.toggleBody(tabItem.dataset.index, 'select')
  },
}

export default Tabs
